module.exports = __webpack_public_path__ + "img/cp_wqjc01.9064a581.png";